<script>
  import { useUrlParams } from "@stores/urlStore.js";
  import { activitiesStoreProject } from "@stores/projectStores.js";
  import { fetchWithSession } from "../util/fetchWithSession";
  import {
    DataTable,
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
  } from "carbon-components-svelte";
  import { Pagination, Button, TextInput } from "paxray-components-svelte";
  import Modal from "lib/components/Modal.svelte";
  import { EDIT_ICON, SAVE_ICON, TRASH_ICON } from '@utils/icons.js';

  export let selectedNode;
  export let selectedNodes;
  export let subprocessMenuOpen;
  export let activitiesToShow;
  export let graphActivities;

  let editActivityName = "";
  let editActivityColor = "#93EDA3";
  let editActivityId = "";

  const {
    deleteActivity,
    saveActivity,
    updateNodeActivity,
    addRecordsToActivity,
    //getActivityByNode
  } = activitiesStoreProject;

  const urlParams = useUrlParams();
  $: ({ idproject } = $urlParams);
  $: allActivities = $activitiesStoreProject.allActivities || [];
  let activityname;
  let filteredRowIds = [];
  let pageSize = 10;
  let page = 1;
  let deleteActivityModalOpen = false;
  let activityid;
  let selectedActivityId = [];
  let editids = [];
  let namedict = {};
  let colorDict = {};

  $: getActivityIdByNodeSelected(selectedNode);

  function getActivityIdByNodeSelected(selectedNode) {
    if (!selectedNode) return;
    const [nodeid, step_number] = selectedNode.split("_");

    if (!step_number) {
      activityid = [];
      activityname = "None";
    } else {
      const activityInGraph = graphActivities.find((activity) =>
        (activity.activity_mapping_step_recordings || []).find(
          (reg) =>
            reg.recording_id === nodeid &&
            reg.step_number === parseInt(step_number),
        ),
      );
      const currentActivity = activitiesToShow.find(
        (activity) => activity.id.split("_")[0] === activityInGraph?.id,
      );
      activityname = currentActivity?.activity_name || "None";
      activityid = [currentActivity?.id] || [];
      selectedActivityId = [currentActivity?.id.split("_")[0]] || [];
    }
  }

  function getActivityByNode(node) {
    if (!node) return null;
    const [nodeid, step_number] = node.split("_");
    for (const activity of graphActivities) {
      const recording = (activity.activity_mapping_step_recordings || []).find(
        (reg) =>
          reg.recording_id === nodeid &&
          reg.step_number === parseInt(step_number),
      );
      if (recording) {
        return { ...recording, activity_id: activity.id };
      }
    }
    return null;
  }

  async function updateSubgraph() {
    if (!selectedNodes.includes(selectedNode)) {
      selectedNodes = [...selectedNodes, selectedNode];
    }
    //console.log({ selectedNodes, selectedNode });
    let sendData = selectedNodes;
    const listOfRecords = [];
    if (selectedNodes.length >= 1) {
      const promises = selectedNodes.map((node) => {
        const activity = getActivityByNode(node);
        if (!activity) {
          const [nodeid, step_number] = node.split("_");
          const recording_entry = {
            recording_id: nodeid,
            step_number: parseInt(step_number),
          };
          listOfRecords.push(recording_entry);
          return Promise.resolve();
        } else if (activity.id !== selectedActivityId[0]) {
          return updateNodeActivity(activity, selectedActivityId[0]);
        }
        return Promise.resolve();
      });

      await Promise.all(promises);
      //console.log("updateSubgraph", { listOfRecords, selectedActivityId });

      if (listOfRecords.length > 0) {
        await addRecordsToActivity(
          listOfRecords,
          selectedActivityId[0],
          graphActivities,
        );
      }
      selectedNodes = [];
      selectedNode = null;
    }
  }
</script>

<Modal
  bind:open={subprocessMenuOpen}
  modalHeading="Add to Activity"
  primaryButtonText="Add to Activity"
  secondaryButtonText="Cancel"
  actions
  autowidth
  on:click:button--secondary={() => {
    subprocessMenuOpen = false;
    selectedActivityId = [];
  }}
  primaryButtonAction={() => {
    updateSubgraph();
    subprocessMenuOpen = false;
  }}
  size="sm"
>
  <DataTable
    size="compact"
    rows={allActivities}
    sortable
    {pageSize}
    {page}
    headers={[
      {
        key: "activity_name",
        value: "Activity",
      },
      {
        key: "color",
        value: "Color",
      },
      {
        key: "menu",
        empty: true,
      },
    ]}
    radio
    bind:selectedRowIds={selectedActivityId}
  >
    <Toolbar>
      <ToolbarContent>
        <ToolbarSearch shouldFilterRows bind:filteredRowIds />
      </ToolbarContent>
    </Toolbar>
    <svelte:fragment slot="cell" let:cell let:row>
      {#if !editids.includes(row.id)}
        {#if cell.key == "color"}
          <input
            type="color"
            value={cell.value}
            disabled
            style="border:1px solid #grey; background-color:white;"
          />
        {:else if cell.key == "menu"}
          <Button
            iconDescription="Edit"
            size="small"
            kind="secondary"
            icon={EDIT_ICON}
            on:click={() => {
              editids.push(row.id);
              editids = editids;
              namedict[row.id] = row.activity_name;
              colorDict[row.id] = row.color;
            }}
          />
          <Button
            iconDescription="Delete"
            size="small"
            kind="danger"
            icon={TRASH_ICON}
            on:click={() => {
              editActivityId = row.id;
              deleteActivityModalOpen = true;
            }}
          />
        {:else}
          {cell.value}
        {/if}
      {:else if cell.key == "color"}
        <input
          type="color"
          bind:value={colorDict[row.id]}
          style="border:1px solid #ff5f1f; background-color:white;"
        />
      {:else if cell.key == "menu"}
        <Button
          iconDescription="Save"
          size="small"
          kind="secondary"
          icon={SAVE_ICON}
          on:click={() => {
            saveActivity(
              namedict[row.id],
              colorDict[row.id],
              row.id,
              idproject,
            );
            editids = editids.filter((id) => id != row.id);
            editids = editids;
          }}
        />
      {:else}
        <TextInput bind:value={namedict[row.id]} size="sm" />
      {/if}
    </svelte:fragment>
  </DataTable>
  <Pagination
    dark
    bind:pageSize
    bind:page
    totalItems={filteredRowIds.length}
    pageSizeInputDisabled
  />
  <div class="inputwrapper">
    <TextInput
      size="sm"
      labelText="Add New Activity"
      placeholder="Define Activity Name"
      bind:value={editActivityName}
    />
    <input
      type="color"
      bind:value={editActivityColor}
      style="margin-top:56px; border:1px solid #ff5f1f; background-color:white; width:80px;"
    />
    <Button
      iconDescription="Add"
      size="small"
      kind="secondary"
      icon={SAVE_ICON}
      on:click={() => {
        saveActivity(editActivityName, editActivityColor, null, idproject);
      }}
    />
  </div>
</Modal>

<Modal
  bind:open={deleteActivityModalOpen}
  kind="danger"
  actions
  autowidth
  modalHeading="Delete Activity?"
  primaryButtonText="Delete"
  secondaryButtonText="Cancel"
  on:click:button--secondary={() => (deleteActivityModalOpen = false)}
  primaryButtonAction={() => {
    editActivityId = editActivityId;
    deleteActivity(editActivityId, idproject);
    deleteActivityModalOpen = false;
  }}
  size="sm"
>
  This will delete the activity. All elements will be reset to no activity.
</Modal>

<style>
  .inputwrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
</style>
